import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/toolbox_topics',
    name: 'ToolboxTopic',
    component: {
      name: 'AdminToolboxTopic',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'toolbox_topic',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminToolboxTopicIndex',
        component: () => import('../views/ToolboxTopicAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminToolboxTopicNew',
        component: () => import('../views/ToolboxTopicAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminToolboxTopicIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminToolboxTopicShow',
        component: () => import('../views/ToolboxTopicAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminToolboxTopicIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminToolboxTopicDetails',
            component: () => import('../views/ToolboxTopicAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminToolboxTopicIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminToolboxTopicEdit',
            component: () => import('../views/ToolboxTopicAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminToolboxTopicDetails' },
            },
          },
          {
            path: 'toolbox_assignments',
            name: 'AdminToolboxTopicTopicAssignments',
            component: () => import('../views/toolboxAssignment/ToolboxTopicToolboxAssignments.vue'),
            meta: {
              backRoute: { name: 'AdminToolboxTopicIndex' },
              resource: 'toolbox_assignment',
            },
          },
          {
            path: 'attachments',
            name: 'AdminToolboxTopicAttachments',
            component: () => import('../views/ToolboxTopicAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminToolboxTopicIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminToolboxTopicAttachmentsEdit',
            component: () => import('../views/ToolboxTopicAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminToolboxTopicAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));